@if (routeIsLoading$ | async) {
  <tp-spinner/>
}

<router-outlet/>
